module.exports = __webpack_public_path__ + "img/DMD.30099359.svg";